import { Component } from '@angular/core'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'
import { Persona } from 'se-resource-types/dist/lib/CentralService/Profiles'

@Component({
  selector: 'se-po-persona-avatar-group-docs',
  templateUrl: './persona-avatar-group-docs.component.html',
  styleUrls: ['./persona-avatar-group-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarGroupDocsComponent {

  public profiles: UserProfile[]

  public constructor() {
    this.profiles = [
      {
        persona: {
          id: 0,
          name: 'Junior Test',
          profile_images: [
            {
              image_type: 'crop',
              url: 'https://images.nbcolympics.com/sites/default/files/post/short_form_video/oly22_st_SMD_bineymini__635693.jpg'
            }
          ]
        } as Persona
      } as UserProfile,
      {
        persona: {
          id: 1,
          name: 'Senior Test'
        } as Persona
      } as UserProfile,
      {
        persona: {
          id: 2,
          name: 'Other Test'
        } as Persona
      } as UserProfile,
      {
        persona: {
          id: 3,
          name: 'Another Test'
        } as Persona
      } as UserProfile,
      {
        persona: {
          id: 4,
          name: 'Test 5'
        } as Persona
      } as UserProfile,
      {
        persona: {
          id: 5,
          name: 'Test 6'
        } as Persona
      } as UserProfile,
      {
        persona: {
          id: 6,
          name: 'Test 7'
        } as Persona
      } as UserProfile
    ]
  }

}
